// extracted by mini-css-extract-plugin
export default {"profileCard":"profile-card_profileCard__J3Va2","copyIcon":"profile-card_copyIcon__4a5hE"};